// A pasted media link, checked before it is sent: a whole web address or nothing.
export const NOT_A_LINK = 'That is not a web address. Paste a full link starting with https://';

/** Why a pasted link cannot be added, before asking the API; null when it looks like one. */
export function linkProblem(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return NOT_A_LINK;
    if (!u.hostname.includes('.')) return NOT_A_LINK;
    return null;
  } catch {
    return NOT_A_LINK;
  }
}
